import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import { journal } from "@/data/site";

const EASE = [0.22, 1, 0.36, 1];

export default function Journal() {
    return (
        <div data-testid="page-journal">
            <PageHeader
                eyebrow="Journal — long-form notes"
                title={<>Notes on building, <em className="italic text-lime">slowly.</em></>}
                lead="A quarterly essay series by the studio principals. On materials, monsoon, cities, and time."
            />
            <section className="relative bg-forest-950 py-16 md:py-24">
                <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                    <ul className="divide-y divide-white/10 border-y border-white/10">
                        {journal.map((j, i) => (
                            <motion.li
                                key={j.slug}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-10% 0px" }}
                                transition={{ duration: 0.9, ease: EASE, delay: i * 0.05 }}
                                data-testid={`journal-row-${j.slug}`}
                            >
                                <Link
                                    to={`/journal/${j.slug}`}
                                    className="group grid grid-cols-12 items-center py-8 md:py-12 gap-6"
                                >
                                    <div className="col-span-2 md:col-span-1 font-mono-mini text-[10px] tracking-[0.32em] uppercase text-lime">
                                        {j.chapter}
                                    </div>
                                    <div className="col-span-10 md:col-span-6">
                                        <h3 className="font-serif-display text-2xl md:text-4xl leading-tight text-ivory group-hover:text-lime transition-colors">
                                            {j.title}
                                        </h3>
                                    </div>
                                    <div className="hidden md:block md:col-span-2 font-mono-mini text-[10px] tracking-[0.28em] uppercase text-ivory/50">
                                        {j.date}
                                    </div>
                                    <div className="hidden md:block md:col-span-2 font-mono-mini text-[10px] tracking-[0.28em] uppercase text-ivory/50">
                                        {j.readTime}
                                    </div>
                                    <div className="col-span-12 md:col-span-1 md:justify-self-end">
                                        <span className="inline-flex h-11 w-11 items-center justify-center border border-ivory/20 text-ivory/80 group-hover:bg-lime group-hover:border-lime group-hover:text-forest-900 transition-colors">
                                            <ArrowUpRight size={16} strokeWidth={1.5} />
                                        </span>
                                    </div>
                                </Link>
                            </motion.li>
                        ))}
                    </ul>
                </div>
            </section>
        </div>
    );
}
